import ShortUniqueId from 'short-unique-id';

const uid = new ShortUniqueId({
    dictionary: 'alphanum_upper', length: 10
  });

export function shortid(){
    return uid.rnd();

}